import React, {Fragment} from 'react';
import { Container, Paper } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import Carousel from "nuka-carousel";
import Fade from '@mui/material/Fade';
import constructionPhoto from '../../img/stedman-for-senate-bust.png';
import senatePhoto from '../../img/stedman-for-senate-addresses-senate-cropped.png';
import EdgecumbeBg from '../../img/edgecumbe-bg.jpeg';
import EdgecumbeBg2 from '../../img/edgecumbe-bg-2.jpeg';
import HarborBg from '../../img/sitka-harbor-bg.jpeg';
import Star from '../../img/line-star.png';
import Construction from '../../img/bert-stedman-for-senate-construction.png';

const useStyles = makeStyles(theme => ({
	home: {
		// backgroundColor: '#fff',
		// padding: '200px 0 200px 0',
		textAlign: 'center',
	},
	carousel: {
		'& img': {
			width:'100%',
		},
		'& .slider-control-topcenter': {
			alignSelf: 'center',
		},
	},
	homeContent: {
		background: '#F5FAFD',
	},
	textContainer: {
		alignSelf: 'center',
	},
	constructionPhoto: {
		position: 'relative',
		display: 'flex',
		justifyContent: 'space-between',
		'& img': {
			backgroundImage: constructionPhoto,
			height: 'fit-content',
		},
		'& .blur': {
			width: '100%',
			position: 'absolute',
			bottom: '0px',
			top: '0px',
			boxShadow: 'inset 0px 0px 10px 20px white',
		}
	},
	constructionBust: {
		alignSelf: 'center',
	},
	verbage: {
		fontSize: '48px',
		lineHeight: '24px',
		fontFamily: '',
		fontStyle: 'italic',
		fontWeight: 'bold',
		color: '#0A2466',
	},
	contentContainer: {
		color: '#0A2466',
		padding: '20px',
		margin: '40px',
	},
	firstContent: {
		textAlign: 'center',
		padding: '0px',
		color: '#0A2466',
		marginBottom: '20px',
		borderBottom: '2px solid #0A2466',

		'& h1': {
			margin: '0',
			fontSize: '98px',
			fontFamily: 'math',
			position: 'relative',
			top: '0px',
		}
	},
	lineStar: {
		width: '90%',
		margin: 'auto',
		filter: 'invert(47%) sepia(7%) saturate(2909%) hue-rotate(1deg) brightness(90%) contrast(83%)',
	},
	constructionContent: {
		paddingTop: '20px',
		display: 'flex',
		justifyContent: 'space-around',
		alignItems: 'center',
	},
	constructionContentParagraph: {
		fontFamily: 'math',
		color: '#0A2466',
		width: '50%',
		padding: '20px',
		'& h2': {
			fontSize: '48px',
		},
		'& h3': {
			fontSize: '32px',
		},
		'& p': {
			fontSize: '28px',
		}
	}
}));

const sliderContent = (currentSlide) => {
	const classes = useStyles();

		return(
			<Fragment>
				{(currentSlide === 0 &&
				<Fade in={currentSlide === 0} timeout={{enter: 1000, exit: 100}}>
					<div className={classes.textContainer}>
						<div className={classes.home}>
							<div className={classes.verbage}>
								<p>Re-elect</p>
								<p>Proven Leadership for</p>
								<p>Southeast Alaska</p>
							</div>
						</div>
					</div>
				</Fade>)}
				{(currentSlide === 1 &&
				<Fade in={currentSlide === 1} timeout={{enter: 1000, exit: 100}}>
					<div className={classes.textContainer}>
						<div className={classes.home}>
							<div className={classes.constructionPhoto}>
								{/*<img src={senatePhoto} alt="Senator Bert Stedman Construction Ceremony"/>*/}
								{/*<img className={classes.constructionBust} src={constructionPhoto}*/}
								{/*	 alt="Senator Bert Stedman Construction Ceremony"/>*/}
								{/*<div className='blur'></div>*/}
							</div>
							<div className={classes.verbage}>
								<p>Bert Stedman for Senate</p>
							</div>
						</div>
					</div>
				</Fade>)}
				{(currentSlide === 2 &&
				<Fade in={currentSlide === 2} timeout={{enter: 1000, exit: 100}}>
					<div className={classes.textContainer}>
						<div className={classes.home}>
							<div className={classes.constructionPhoto}>
								{/*<img src={senatePhoto} alt="Senator Bert Stedman Construction Ceremony"/>*/}
								{/*<img className={classes.constructionBust} src={constructionPhoto}*/}
								{/*	 alt="Senator Bert Stedman Construction Ceremony"/>*/}
								{/*<div className='blur'></div>*/}
							</div>
							<div className={classes.verbage}>
								<p>Proven Leadership</p>
							</div>
						</div>
					</div>
				</Fade>)}
			</Fragment>
		)
}

const Home = () => {
	const classes = useStyles();

	return (
	<div className={classes.homeContent}>
		{/*<div className={classes.carousel}>*/}
		{/*	<Carousel*/}
		{/*		autoplay*/}
		{/*		autoplayInterval={5000}*/}
		{/*		renderTopCenterControls={({ currentSlide }) => sliderContent(currentSlide)}*/}
		{/*	>*/}
		{/*		<img src={EdgecumbeBg} alt='Stedman for Senate Edgecumbe background'/>*/}
		{/*		<img src={EdgecumbeBg2} alt='Stedman for Senate Edgecumbe background'/>*/}
		{/*		<img src={HarborBg} alt='Stedman for Senate harbor background'/>*/}
		{/*	</Carousel>*/}
		{/*</div>*/}
		<Container>
			<div className={classes.firstContent}>
				<h1>Stedman for Senate</h1>
				<img className={classes.lineStar} src={Star} alt="Stedman for Senate line graphic with star"/>
				<div className={classes.constructionContent}>
					<img src={Construction} alt=""/>
					<Paper elevation={5} className={classes.constructionContentParagraph}>
						<h2>Bert Stedman</h2>
						<h3>Committed to Southeast</h3>
						<p>Building Southeast Alaska since 2003</p>
					</Paper>
				</div>
			</div>
			{/* <Paper
				elevation={10}
				className={classes.home}
			>
				<div className={classes.contentContainer}>
					<div className={classes.verbage}>
						<p>Re-elect Proven Leadership</p>
						<p>for Southeast Alaska</p>
					</div>
					<div className={classes.constructionPhoto}>
						<img src={senatePhoto} alt="Senator Bert Stedman Construction Ceremony"/>
						<img className={classes.constructionBust} src={constructionPhoto} alt="Senator Bert Stedman Construction Ceremony"/>
					</div>
				</div>
			</Paper> */}
			<Paper elevation={10}>
				<div className={classes.contentContainer}>
					<h1>Contact</h1>
					<h2>bert@stedmanforsenate.com</h2>
					<h2>118 American Street, Sitka, Alaska, 99835</h2>
				</div>
			</Paper>
		</Container>
	</div>
  )
}

export default Home;
